// extracted by mini-css-extract-plugin
module.exports = {"root":"Paginator_root__1z-Ua","endcap":"Paginator_endcap__2RO8F","page-root":"Paginator_page-root__3Gjsi","page":"Paginator_page__PkH6m","current":"Paginator_current__82eHE"};